import { createAsyncThunk } from "@reduxjs/toolkit";
import { del, get, post } from "../../../api/api";
import { IAddEditUser } from "../../../models/users";
import { setLoading } from "../../../app/loadingSlice";

//Call fetch users api request
export const fetchUsers = createAsyncThunk("users", async (_, { dispatch }) => {
    dispatch(setLoading(true));
    try {
        const response = await get("/users")
        return response;
    }
    catch (error) {
        console.log(error);
    }
    finally {
        dispatch(setLoading(false));
    }
});

//Call fetch users by id api request
export const fetchUserById = createAsyncThunk("users/id", async (userId: number, { dispatch }) => {
    dispatch(setLoading(true));
    try {
        const response = await get(`/user/${userId}`)
        return response;
    }
    catch (error) {
        console.log(error);
    }
    finally {
        dispatch(setLoading(false));
    }
});

//Call create users api request
export const createUser = createAsyncThunk("users/create", async (user: IAddEditUser, { dispatch }) => {
    dispatch(setLoading(true));
    try {
        const response = await post("/user/create", user);
        return response.data;
    }
    catch (error) {
        console.log(error);
    }
    finally {
        dispatch(setLoading(false));
    }
});

//Call create users api request
export const editUser = createAsyncThunk("users/edit", async (user: IAddEditUser, { dispatch }) => {
    dispatch(setLoading(true));
    try {
        const response = await post("/user/edit", user);
        return response.data;
    }
    catch (error) {
        console.log(error);
    }
    finally {
        dispatch(setLoading(false));
    }
});

//Call delete users api request
export const deleteUser = createAsyncThunk("users/delete", async (userId: number, { dispatch }) => {
    dispatch(setLoading(true));
    try {
        const response = await del(`/user/delete/${userId}`);
        return response;
    }
    catch (error) {
        console.log(error);
    }
    finally {
        dispatch(setLoading(false));
    }
});

//Call update status user api
export const changeUserStatus = createAsyncThunk("users/changeUserStatus", async (userId: number, { dispatch }) => {
    dispatch(setLoading(true));
    try {
        const response = await post("/user/update-status", { id: userId });
        return response.data;
    }
    catch (error) {
        console.log(error);
    }
    finally {
        dispatch(setLoading(false));
    }
});
